import DCircleLoader from "@UI/components/Atoms/Loader/DCircleLoader";

const BootScreen = () => (
  <div className="d-flex d-align-center d-justify-center d-height-100-vh">
    <DCircleLoader width="48px" height="48px" />
  </div>
);

export default BootScreen;
